import React from "react";
import styled from "styled-components";
import TimeStamp from "./TimeStamp";
import VictimDetails from "./VictimDetails";

const Sidebar = () => {
  return (
    <SidebarContainer>
      <TimeStamp />
      <VictimDetails />
    </SidebarContainer>
  );
};

export default Sidebar;

const SidebarContainer = styled.div`
  border-right: 1px solid var(--lightGray);
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 10px;
  }
  /* ::-webkit-scrollbar-track {
    box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.3);
  } */
  ::-webkit-scrollbar-thumb {
    background-color: var(--lightGray);
    border-radius: 10px;
    /* outline: 1px solid var(--orange); */
  }
  ::-webkit-scrollbar-thumb:hover {
    background: var(--darkGray);
  }
  cursor: pointer;
  /* box-shadow: 1px 0px 5px var(--lightGray); */
  height: 90vh;
`;
